import tw, { styled } from 'twin.macro';

const FlexGrow = styled.div`
  ${tw`flex-grow`}
`;

export default FlexGrow;
